import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import "./packaging-delivery-section-video.scss"

const PackagingDeliverySectionVideo = () => {
  const resultQuery = useStaticQuery(
    graphql`
      query PACKAGING_DELIVERY_VIDEO {
        allContentfulNolHomeSegundoNivel(
          filter: { slug: { in: ["mis-puntos","mis-puntos/"] } }
        ) {
          edges {
            node {
              urlVideoEntregaEmpaques
              node_locale
            }
          }
        }
      }
    `
  )

  const packagingVideo = resultQuery.allContentfulNolHomeSegundoNivel.edges.filter(
    e => e.node.node_locale === process.env.LOCALE
  )[0].node.urlVideoEntregaEmpaques

  if (packagingVideo !== "contenido-oculto") {
    return (
      <div className="f-PackagingDeliverySectionVideo-container">
        <iframe
          className="f-PackagingDeliverySectionVideo-container__video"
          frameBorder="0"
          sandbox="allow-popups allow-same-origin allow-scripts"
          scrolling="no"
          src={
            packagingVideo.includes("youtube")
              ? packagingVideo.replace("watch?v=", "embed/")
              : packagingVideo.includes("youtu.be")
              ? packagingVideo.replace(".be/", "be.com/embed/")
              : packagingVideo
          }
          allowFullScreen={true}
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          sandbox="allow-forms allow-scripts allow-same-origin"
        />
      </div>
    )
  } else {
    return null
  }
}

export default PackagingDeliverySectionVideo
